import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router';

import { Button } from '@ds/core';
import { EmptyState } from '@ds/feedback';
import { baseDaSessao } from './guardas';

interface Explicacao {
    icon: string;
    titulo: string;
    descricao: string;
}

function explicar(erro: unknown): Explicacao {
    if (isRouteErrorResponse(erro)) {
        if (erro.status === 404) {
            /* Módulo desligado por feature flag também é 404, mas de outro
               tipo: a tela existe no produto e não existe NESTA clínica. Dizer
               "o endereço não corresponde a nenhuma tela" mandaria a pessoa
               procurar erro de digitação. O `statusText` é quem separa os dois
               — o 404 de rota inexistente vem do próprio roteador, com uma
               mensagem de desenvolvimento no `data`. */
            const dito = erro.statusText === 'Módulo não habilitado' && typeof erro.data === 'string'
                ? erro.data
                : undefined;
            return {
                icon: 'compass',
                titulo: dito ? 'Esta tela não está disponível aqui' : 'Esta página não existe',
                descricao: dito
                    ?? 'O endereço não corresponde a nenhuma tela da Fórmula MED. Pode ter sido digitado errado, ou o link é de uma versão anterior.',
            };
        }
        if (erro.status === 403) {
            return {
                icon: 'lock',
                titulo: 'Você não tem acesso a esta tela',
                /* Dizer QUAL permissão falta é o que separa "sem acesso" de
                   "quebrado": com o nome, a pessoa sabe o que pedir a quem
                   administra a conta. */
                descricao: typeof erro.data === 'string' && erro.data ? erro.data : 'A sua conta não tem a permissão exigida por esta rota.',
            };
        }
        return { icon: 'triangle-alert', titulo: `Erro ${erro.status}`, descricao: erro.statusText || 'A navegação falhou.' };
    }

    return {
        icon: 'triangle-alert',
        titulo: 'Algo quebrou nesta tela',
        descricao: erro instanceof Error ? erro.message : 'Erro inesperado ao montar a rota.',
    };
}

/** Fronteira de erro do roteador: 404, 403 e falha inesperada. */
export function ErroDeRota() {
    const erro = useRouteError();
    const navigate = useNavigate();
    const { icon, titulo, descricao } = explicar(erro);

    return (
        <main style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--surface-secondary)' }}>
            <EmptyState
                icon={icon} title={titulo} description={descricao}
                action={<Button onClick={() => navigate(baseDaSessao(), { replace: true })}>Voltar ao início</Button>}
                secondaryAction={<Button variant="ghost" onClick={() => navigate(-1)}>Voltar à página anterior</Button>}
            />
        </main>
    );
}
